module.exports = __webpack_public_path__ + "static/media/landing_trust.8d521bac.png";